import { ERROR_CALLBACK_TYPES } from 'in-meeting-experience-ui-components/constants/errors';
import { getHostApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import noAuthClient from '../../utils/apiClient';
const API_BASE = `${getHostApiUrl()}/embedded-view-auth`;
export const fetchPortalUserInfo = () => noAuthClient.get(`${API_BASE}/portal-user-info`, {
  errorCallback: ERROR_CALLBACK_TYPES.authentication
});
export const fetchUserInfo = ({
  ignoreErrors = false
}) => noAuthClient.get(`${API_BASE}/user-info`, {
  ignoreErrors,
  errorCallback: ERROR_CALLBACK_TYPES.authentication
});